module.exports = __webpack_public_path__ + "static/media/greenMutagen.2f051206.png";